// extracted by mini-css-extract-plugin
export default {"media":"CardMedia_media__m+VOB","play":"CardMedia_play__Cu1+W"};